import React from 'react'
import 'storyblok-rich-text-react-renderer'

import { ButtonModifier } from '@components/atoms/Button/Button'
import Col from '@components/atoms/Grid/Col'
import Row from '@components/atoms/Grid/Row'
import { HeadlineImportances } from '@components/atoms/Headline/Headline'
import { TextVariants } from '@components/atoms/Text/Text'
import StoryblokRichText from '@components/storyblok/atoms/StoryblokRichText'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { editable } from '@helper/storyblokEditable'

import {
  Button,
  ImageLink,
  TextSection,
} from '@definitions/types/storyblokTypes'
import StoryblokImageLink from '@components/storyblok/atoms/StoryblokImageLink'

import {
  RichText,
  Root,
  StyledButtonContainer,
  StyledHeadline,
  StyledLinkButton,
  StyledText,
} from './StoryblokTextSection.styles'

interface Props extends PropsWithClassName {
  blok: TextSection
}

const StoryblokTextSection = (props: Props): React.JSX.Element => {
  const { blok } = props
  function renderButtons(button: Button | ImageLink, index: number) {
    if (button.component === 'button') {
      return (
        <StyledLinkButton
          alignment={blok.alignment ?? 'center'}
          key={button.label ?? index}
          disabled={false}
          loading={false}
          label={button.label ?? ''}
          href={button.link?.cached_url ?? ''}
          modifier={ButtonModifier.PRIMARY}
        >
          {button.label}
        </StyledLinkButton>
      )
    } else {
      return (
        <StoryblokImageLink
          key={button._uid ?? index}
          blok={button}
        />
      )
    }
  }
  return (
    <Root
      {...editable(blok)}
      key={blok._uid}
      className={props.className}
      data-testid={'storyblok-text-section-root'}
      paddingTop={blok.paddingTop ?? false}
      alignment={blok.alignment ?? 'center'}
    >
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <StyledHeadline
            alignment={blok.alignment ?? 'center'}
            importance={HeadlineImportances.h2}
          >
            {blok.headline?.toString()}
          </StyledHeadline>
          <StyledText
            alignment={blok.alignment ?? 'center'}
            variant={TextVariants.lead}
          >
            {blok.lead?.toString()}
          </StyledText>
          <RichText alignment={blok.alignment ?? 'center'}>
            <StoryblokRichText content={blok.text} />
          </RichText>
          <StyledButtonContainer>
            {blok.button &&
              blok.button.length > 0 &&
              blok.button.map((button, index: number) =>
                renderButtons(button, index)
              )}
          </StyledButtonContainer>
        </Col>
      </Row>
    </Root>
  )
}

export { StoryblokTextSection }
